/* app/js/src/components/import-segments-csv/import-segments-csv.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  overflow: hidden;
  background-color: #f1f3f4;
}
.container .header {
  margin-bottom: 20px;
  margin-top: 20px;
}
.container .inputUploadSegmnetsCsv input {
  color: #232f3a;
  font-size: 13px;
  border-radius: 4px;
  background-color: #fff;
  padding: 6px 9px;
  border: 1px solid #e1e6eb;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  vertical-align: middle;
}
.container .inputUploadSegmnetsCsv:hover {
  border-color: #40c4ff;
}
.container .footer {
  margin-top: 30px;
}
.container .upload-segments-result {
  background-color: white;
}
.container .upload-segments-result th,
.container .upload-segments-result td {
  border: 1px solid #f1f3f4;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 20px;
}
/*# sourceMappingURL=import-segments-csv.component.css.map */
